import { render } from "./FinancialAdvisorPage.vue?vue&type=template&id=ed18b6c6&scoped=true&ts=true"
import script from "./FinancialAdvisorPage.vue?vue&type=script&lang=ts"
export * from "./FinancialAdvisorPage.vue?vue&type=script&lang=ts"

import "./FinancialAdvisorPage.vue?vue&type=style&index=0&id=ed18b6c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed18b6c6"]])

export default __exports__